jQuery.fn.dataTableExt.oApi.fnSetFilteringDelay = function ( oSettings, iDelay ) {
  var _that = this;
  this.each( function ( i ) {
    $.fn.dataTableExt.iApiIndex = i;
    iDelay  = (iDelay && (/^[0-9]+$/.test(iDelay))) ? iDelay : 250;

    var $this = this, oTimerId;
    // Ensure 'f' (filtering) feature is enabled in DataTable options for this to work
    var settings = _that.fnSettings();
    if (!settings || !settings.aanFeatures || !settings.aanFeatures.f) {
      console.warn('fnSetFilteringDelay: No filter feature found in DataTable');
      return this;
    }
    
    var anControl = $( 'input', settings.aanFeatures.f );

    anControl.off( 'keyup.DT' ).on( 'keyup.DT', function() { // Use namespaced event
      var $$this = $this; // Unused variable?
      window.clearTimeout(oTimerId);

      oTimerId = window.setTimeout(function() {
        $.fn.dataTableExt.iApiIndex = i; // Ensure context is correct if needed
        _that.fnFilter( anControl.val() );
      }, iDelay);
    });

    return this;
  } );
  return this;
}

// Selectors for all tables managed by this script
const REMOTE_TABLE_SELECTORS = [
  '.remote-data-table',
  '.new-remote-data-table',
  '.new-sortable-remote-data-table',
  '.new-remote-data-table-meetings',
  '.new-remote-data-table-opportunities',
  '.new-remote-data-table-fulfillment-requests',
  '.new-remote-data-table-logs',
  '.new-remote-data-table-checkboxes',
  '.remote-data-table-sort-registration',
  '.remote-submissions-table'
].join(', ');

let isInitialized = false;
let currentTables = new Set();

function destroyRemoteDataTables() {
  console.log("Attempting to destroy remote DataTables..."); // Debug log
  document.querySelectorAll(REMOTE_TABLE_SELECTORS).forEach(table => {
    if ($.fn.DataTable.isDataTable(table)) {
      console.log("Destroying DataTable:", table); // Debug log
      $(table).DataTable().destroy();
      // Optionally clear headers/footers if they are dynamically added by DataTables
      // $(table).empty(); // Be careful with empty(), might remove structure needed for re-init
      $(table).find('thead, tfoot').empty(); // Safer alternative if needed
    }
  });
}

function destroyExistingTables() {
  currentTables.forEach(table => {
    if ($.fn.DataTable.isDataTable(table)) {
      $(table).DataTable().destroy();
      $(table).empty();
    }
  });
  currentTables.clear();
}

function initializeRemoteDataTables() {
  console.log("Initializing remote DataTables..."); // Debug log
  // Destroy any potentially lingering tables first (e.g., from bfcache restore without turbo:before-cache firing)
  destroyRemoteDataTables();

  // Track which tables we're initializing
  document.querySelectorAll(REMOTE_TABLE_SELECTORS).forEach(table => {
    currentTables.add(table);
  });

  if (isInitialized) {
    destroyExistingTables();
  }

  // --- Initialization logic for '.remote-data-table' ---
  $('.remote-data-table').each( function() {
    var that = $(this);
    // Check if already initialized (belt-and-suspenders)
    if ($.fn.DataTable.isDataTable(this)) {
      console.log("Skipping already initialized table:", this); // Debug log
      return;
    }
    console.log("Initializing .remote-data-table:", this); // Debug log
    try {
      $(this).dataTable( {
        "bProcessing": true,
        "bServerSide": true,
        "bSort": false,
        "sAjaxSource": that.attr("data-resource"),
        "bStateSave": true, // State saving might conflict with Turbo's caching, test carefully
        "bDestroy": true, // Add destroy option
        "bAutoWidth": false,
        "fnServerData": function( sSource, aoData, fnCallback, oSettings) {
          // Ensure notefit_config is available
          if (typeof notefit_config === 'undefined' || !notefit_config.api_auth_token || !notefit_config.team_api_auth_token) {
            console.error("notefit_config not available for DataTable AJAX request");
            return;
          }
          oSettings.jqXHR = $.ajax( {
            "dataType": 'json',
            "type": 'GET',
            "url": sSource,
            "data": aoData,
            "success": fnCallback,
            "headers": { "X-Notefit-Planner-Api-Auth-Token": notefit_config.api_auth_token, "X-Notefit-Team-Api-Auth-Token": notefit_config.team_api_auth_token }
          });
        },
        "fnServerParams": function ( aoData ) {
          if (that.attr("data-scope")) {
            aoData.push( { "name": "scope", "value": that.attr("data-scope") } );
          }
        },
        "fnDrawCallback": function() {
          that.trigger("table_updated", ["Table", "Updated"]);
          // Reinitialize tooltips within the table after draw
          that.find('[data-toggle="tooltip"]').tooltip();
        },
        "bLengthChange": false,
        "sDom": "<'row-fluid'<'span1'l><'span11'f>r>t<'row-fluid'<'span1'i><'span11 pull-right'p>>", // Check if 'f' (filter input) is needed/present
        "sPaginationType": "bootstrap",
        "aaSorting": [ ],
        "oLanguage": {
          "sSearch": "Filter:",
          "sInfo": "",
          "sInfoFiltered": "",
          "sInfoEmpty": ""
        }
      });
      // Only apply filtering delay if sDom includes 'f' (filter)
      if (that.closest('.dataTables_wrapper').find('.dataTables_filter').length > 0) {
        $(this).dataTable().fnSetFilteringDelay();
      }
    } catch (e) {
      console.error("Error initializing .remote-data-table:", e, this);
    }
  });

  // --- Initialization logic for '.new-remote-data-table' ---
  $('.new-remote-data-table').each( function() {
    var that = $(this);
    if ($.fn.DataTable.isDataTable(this)) {
       console.log("Skipping already initialized table:", this); // Debug log
      return;
    }
     console.log("Initializing .new-remote-data-table:", this); // Debug log
    try {
      var options = {
        "serverSide": true,
        "processing": true,
        "ordering": false,
        "responsive": true,
        "stateSave": true, // Test carefully with Turbo
        "destroy": true, // Add destroy option
        "autoWidth": false,
        "ajax": {
          "url": that.attr("data-resource"),
          "type": "GET",
          "beforeSend": function(request) {
            // Ensure notefit_config is available
            if (typeof notefit_config === 'undefined') {
              console.error("notefit_config not available for DataTable AJAX request");
              return false; // Prevent request
            }
            if(that.data('account-auth') && notefit_config.account_api_auth_token) {
              request.setRequestHeader("X-Notefit-Account-Api-Auth-Token", notefit_config.account_api_auth_token);
            } else if (notefit_config.api_auth_token && notefit_config.team_api_auth_token) {
              request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
              request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
            } else {
               console.error("Missing required auth tokens in notefit_config");
               return false; // Prevent request
            }
          }
        },
        "drawCallback" : function() {
          that.trigger("table_updated", ["Table", "Updated"]);
          // Reinitialize tooltips within the table after draw
          that.find('[data-toggle="tooltip"]').tooltip();
        },
        "dom": "<'row-fluid'r>t<'row-fluid'<'span1'><'span11 pull-right'p>>", // No 'f' filter input defined here
        "pagingType": "bootstrap", // Ensure pagination type is set if needed
        "language": { // Add language options if needed
          "search": "Filter:",
          "info": "",
          "infoFiltered": "",
          "infoEmpty": ""
        }
      };
      
      $(this).DataTable(options);
    } catch (e) {
      console.error("Error initializing .new-remote-data-table:", e, this);
    }
  });

  // --- Add similar .each() blocks for other selectors if their options differ ---
  // Example for '.new-sortable-remote-data-table' (adjust options as needed)
  $('.new-sortable-remote-data-table').each( function() {
    var that = $(this);
    if ($.fn.DataTable.isDataTable(this)) return;
    console.log("Initializing .new-sortable-remote-data-table:", this); // Debug log
    try {
      $(this).DataTable({
        "serverSide": true,
        "processing": true,
        "ordering": true, // Enable sorting
        // Add rowReorder options if needed: "rowReorder": { selector: 'td:first-child' },
        "responsive": true,
        "stateSave": true,
        "destroy": true,
        "autoWidth": false,
        "ajax": { /* ... AJAX setup similar to .new-remote-data-table ... */
          "url": that.attr("data-resource"),
          "type": "GET",
          "beforeSend": function(request) {
            if (typeof notefit_config === 'undefined') { console.error("notefit_config missing"); return false; }
            if(that.data('account-auth') && notefit_config.account_api_auth_token) {
              request.setRequestHeader("X-Notefit-Account-Api-Auth-Token", notefit_config.account_api_auth_token);
            } else if (notefit_config.api_auth_token && notefit_config.team_api_auth_token) {
              request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
              request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
            } else { console.error("Auth tokens missing"); return false; }
          }
        },
        "drawCallback" : function() {
          that.trigger("table_updated", ["Table", "Updated"]);
          that.find('[data-toggle="tooltip"]').tooltip();
        },
        "dom": "<'row-fluid'r>t<'row-fluid'<'span1'><'span11 pull-right'p>>",
        "pagingType": "bootstrap",
        "language": { /* ... language options ... */ }
        // Add specific sorting columns if needed: "order": [[ 1, 'asc' ]]
      });
    } catch (e) {
      console.error("Error initializing .new-sortable-remote-data-table:", e, this);
    }
  });

  // --- Initialization logic for '.new-remote-data-table-checkboxes' ---
  $('.new-remote-data-table-checkboxes').each( function() {
    var that = $(this);
    if ($.fn.DataTable.isDataTable(this)) {
       console.log("Skipping already initialized table:", this); // Debug log
      return;
    }
     console.log("Initializing .new-remote-data-table-checkboxes:", this); // Debug log
    try {
      $(this).DataTable( {
        "serverSide": true,
        "processing": true,
        "ordering": false, // Checkboxes table likely doesn't need ordering on other columns
        "responsive": true,
        "stateSave": true, // Test carefully with Turbo
        "destroy": true,
        "autoWidth": false,
        "ajax": {
          "url": that.attr("data-resource"),
          "type": "GET",
          "data": function ( d ) { // Add filter data
            d.has_submissions = $('#has_submissions').val();
            d.has_registrations = $('#has_registrations').val();
          },
          "beforeSend": function(request) {
            if (typeof notefit_config === 'undefined') {
              console.error("notefit_config not available for DataTable AJAX request");
              return false; // Prevent request
            }
            if(that.data('account-auth') && notefit_config.account_api_auth_token) {
              request.setRequestHeader("X-Notefit-Account-Api-Auth-Token", notefit_config.account_api_auth_token);
            } else if (notefit_config.api_auth_token && notefit_config.team_api_auth_token) {
              request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
              request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
            } else {
               console.error("Missing required auth tokens in notefit_config");
               return false; // Prevent request
            }
          }
        },
        "columnDefs": [
           {
              "targets": 0, // Target the first column
              "checkboxes": {
                 "selectRow": true // Enable row selection by clicking the checkbox
              },
              "orderable": false // Disable sorting on the checkbox column
           }
        ],
        "select": {
           "style": 'multi' // Allow multiple rows to be selected
        },
        "order": [[ 1, 'asc' ]], // Optional: Default sort for a non-checkbox column if needed
        "drawCallback" : function() {
          that.trigger("table_updated", ["Table", "Updated"]);
          // Trigger initial check for selected rows display logic
          $(document).trigger('datatable:check_select_logic');
        },
        "dom": "<'row-fluid'r>t<'row-fluid'<'span1'><'span11 pull-right'p>>", // No 'f' filter input defined here
        "pagingType": "bootstrap",
        "language": {
          "search": "Filter:",
          "info": "",
          "infoFiltered": "",
          "infoEmpty": ""
        }
      });
    } catch (e) {
      console.error("Error initializing .new-remote-data-table-checkboxes:", e, this);
    }
  });


  // --- Initialization logic for '.new-remote-data-table-meetings' ---
  $('.new-remote-data-table-meetings, .remote-meetings-table').each( function() {
    var that = $(this);
    if ($.fn.DataTable.isDataTable(this)) {
      console.log("Skipping already initialized meetings table:", this);
      return;
    }
    console.log("Initializing meetings table:", this);
    try {
      $(this).DataTable({
        "serverSide": true,
        "processing": true,
        "ordering": false,
        "responsive": true,
        "stateSave": true,
        "destroy": true,
        "autoWidth": false,
        "ajax": {
          "url": $(this).data('resource'),
          "type": "GET",
          "data": function (d) {
            d.has_canceled = $('#has_canceled').val();
            d.has_scheduled = $('#has_scheduled').val();
            var search = $('[data-table-search="meetings_table"]').val();
            if (search && search !== '') {
              // Override the default search value with our custom search input
              d.search = { value: search };
            }
          },
          "beforeSend": function(request) {
            if (typeof notefit_config === 'undefined') {
              console.error("notefit_config not available for DataTable AJAX request");
              return false;
            }
            if (notefit_config.api_auth_token && notefit_config.team_api_auth_token) {
              request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
              request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
            } else {
              console.error("Auth tokens missing from notefit_config");
              return false;
            }
          }
        },
        "lengthMenu": [10, 25, 50, 100, 250],
        "drawCallback" : function() {
          that.trigger("table_updated", ["Table", "Updated"]);
        },
        "dom": "<'row-fluid'r>t<'row-fluid'<'span1'><'span11 pull-right'p>>",
        "pagingType": "bootstrap",
        "language": {
          "search": "Filter:",
          "info": "",
          "infoFiltered": "",
          "infoEmpty": ""
        }
      });
    } catch (e) {
      console.error("Error initializing .new-remote-data-table-meetings:", e, this);
    }
  });

  // --- Initialization logic for '.new-remote-data-table-opportunities' ---
  $('.new-remote-data-table-opportunities, .remote-opportunities-table').each( function() {
    var that = $(this);
    if ($.fn.DataTable.isDataTable(this)) {
      console.log("Skipping already initialized opportunities table:", this);
      return;
    }
    console.log("Initializing opportunities table:", this);
    try {
      $(this).DataTable({
        "serverSide": true,
        "processing": true,
        "ordering": false,
        "responsive": true,
        "stateSave": true,
        "destroy": true,
        "autoWidth": false,
        "ajax": {
          "url": that.attr("data-resource"),
          "type": "GET",
          "data": function (d) {
            d.search_value = that.data('search-value');
            d.has_pending = $('#has_pending').val() || false;
            d.has_open = $('#has_open').val() || false;
            d.has_closed = $('#has_closed').val() || false;
            d.has_rejected = $('#has_rejected').val() || false;
            d.has_fulfillment_requests = $('#has_fulfillment_requests').val() || false;
            if($("[data-table-search='" + that.data('table') + "']").length > 0) {
              d.search_value = $("[data-table-search='" + that.data('table') + "']").val();
            }
          },
          "beforeSend": function(request) {
            if (typeof notefit_config === 'undefined') {
              console.error("notefit_config not available for DataTable AJAX request");
              return false;
            }
            if(that.data('account-auth') && notefit_config.account_api_auth_token) {
              request.setRequestHeader("X-Notefit-Account-Api-Auth-Token", notefit_config.account_api_auth_token);
            } else if (notefit_config.api_auth_token && notefit_config.team_api_auth_token) {
              request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
              request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
            } else {
              console.error("Missing required auth tokens in notefit_config");
              return false;
            }
          }
        },
        "drawCallback" : function() {
          that.trigger("table_updated", ["Table", "Updated"]);
          that.find('[data-toggle="tooltip"]').tooltip();
        },
        "dom": "<'row-fluid'r>t<'row-fluid'<'span1'><'span11 pull-right'p>>",
        "pagingType": "bootstrap",
        "language": {
          "search": "Filter:",
          "info": "",
          "infoFiltered": "",
          "infoEmpty": ""
        }
      });
    } catch (e) {
      console.error("Error initializing opportunities table:", e, this);
    }
  });

  // --- Initialization logic for '.remote-submissions-table' ---
  $('.remote-submissions-table').each( function() {
    var that = $(this);
    if ($.fn.DataTable.isDataTable(this)) {
      console.log("Skipping already initialized submissions table:", this);
      return;
    }
    console.log("Initializing .remote-submissions-table:", this);
    try {
      $(this).DataTable({
        "serverSide": true,
        "processing": true,
        "ordering": true, // Enable sorting for submissions
        "responsive": true,
        "stateSave": true,
        "destroy": true,
        "autoWidth": false,
        "ajax": {
          "url": that.attr("data-resource"),
          "type": "GET",
          "data": function (d) {
            // Add filter parameters from the filter checkboxes
            d.awaiting_evaluation = $('#awaiting_evaluation').val() || false;
            d.accepted = $('#accepted').val() || false;
            d.rejected = $('#rejected').val() || false;
            d.canceled = $('#canceled').val() || false;
            d.being_evaluated = $('#being_evaluated').val() || false;
            // Add search value from the custom search input
            if($("[data-table-search='" + that.data('table') + "']").length > 0) {
              d.search_value = $("[data-table-search='" + that.data('table') + "']").val();
            }
          },
          "beforeSend": function(request) {
            if (typeof notefit_config === 'undefined') {
              console.error("notefit_config not available for DataTable AJAX request");
              return false;
            }
            if (notefit_config.api_auth_token && notefit_config.team_api_auth_token) {
              request.setRequestHeader("X-Notefit-Planner-Api-Auth-Token", notefit_config.api_auth_token);
              request.setRequestHeader("X-Notefit-Team-Api-Auth-Token", notefit_config.team_api_auth_token);
            } else {
              console.error("Missing required auth tokens in notefit_config");
              return false;
            }
          }
        },
        "drawCallback" : function() {
          that.trigger("table_updated", ["Table", "Updated"]);
          // Reinitialize tooltips within the table after draw
          that.find('[data-toggle="tooltip"]').tooltip();
          // Apply stars rating display
          if($('span.stars:not(:has(span))').length) {
            $('span.stars:not(:has(span))').stars();
          }
        },
        "dom": "<'row-fluid'r>t<'row-fluid'<'span1'><'span11 pull-right'p>>",
        "pagingType": "bootstrap",
        "language": {
          "search": "Filter:",
          "info": "",
          "infoFiltered": "",
          "infoEmpty": ""
        }
      });
    } catch (e) {
      console.error("Error initializing .remote-submissions-table:", e, this);
    }
  });

  // TODO: Add .each() blocks for:
  // .new-remote-data-table-meetings
  // .new-remote-data-table-fulfillment-requests
  // .new-remote-data-table-logs
  // .remote-data-table-sort-registration
  // Ensure options like "ordering", "ajax", "dom", "columns" (if needed) are correct for each type.

  console.log("Finished initializing remote DataTables."); // Debug log
}

// --- Turbo Event Listeners ---

// Destroy tables before Turbo caches the page
document.addEventListener('turbo:before-cache', function() {
  console.log("Turbo event: turbo:before-cache"); // Debug log
  destroyRemoteDataTables();
});

// Initialize tables after Turbo loads a page (fresh or cached)
document.addEventListener('turbo:load', function() {
  console.log("Turbo event: turbo:load"); // Debug log
  initializeRemoteDataTables();
});

// Fallback for initial page load if Turbo isn't ready immediately
// or for non-Turbo environments (though the listeners above should cover Turbo)
// $(document).ready(function() {
//   console.log("Document ready"); // Debug log
//   // Check if tables are already there (e.g., initialized by turbo:load)
//   if (!$(REMOTE_TABLE_SELECTORS).hasClass('dataTable')) { // Basic check
//      initializeRemoteDataTables();
//   }
// });

// Note: Removed isInitialized flag and turbo:before-render listener as the
// destroy-on-cache, init-on-load pattern is generally more robust.

